import React from "react";
import {MailOutlined} from "@ant-design/icons";
import {FormActionButton} from "../components/form";
import {message} from "antd";
import {HttpClient} from "../http/HttpClient";
import {PageSubTitleLabel, PageTitleLabel} from "../components/PageTitle";
import {EventBus} from "../bus/EventBus";

export class EmailConfirmation extends React.Component {
    async resend() {
        const {match} = this.props;
        const {hashedEmail} = match.params;

        try {
            await HttpClient.post("/api/users/email/resend", {
                email: atob(hashedEmail)
            });
            message.success("Success! Check your email.", 0);
        } catch (e) {
            EventBus.triggerError(
                "server-error",
                {content: {description: "Unfortunately we couldn't resend your activation email."}},
                e.message
            );
        }
    }

    render() {
        const {match} = this.props;
        const {hashedEmail} = match.params;
        const email = atob(hashedEmail);

        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    marginTop: 20,
                    padding: 20,
                    paddingTop: 0,
                    marginBottom: 30
                }}>
                <PageTitleLabel>Email confirmation</PageTitleLabel>
                <PageSubTitleLabel style={{textAlign: "center"}}>
                    You need to verify your email to complete registration.
                </PageSubTitleLabel>
                <MailOutlined style={{fontSize: 128, margin: 30, color: "#2F3E83"}} />
                <label style={{fontSize: 16, color: "#8492A6", marginBottom: 10, textAlign: "center", maxWidth: 500}}>
                    An email has been sent to <strong>{email}</strong> with a link to verify your account.
                </label>
                <FormActionButton
                    onClick={() => this.resend()}
                    style={{
                        marginTop: 20,
                        maxWidth: 400,
                        width: "100%",
                        marginLeft: 20,
                        marginRight: 20
                    }}>
                    Resend email
                </FormActionButton>
            </div>
        );
    }
}
